var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Search',{attrs:{"advanced":_vm.advanced},on:{"search-params-updated":_vm.searchParamsUpdated}}),_c('CulturalModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }